<div class="q-page" [attr.dir]="dir()">
  <div class="q-card">

    <!-- loading / load error -->
    <div *ngIf="loading" class="q-center">{{ 'questionnaire.Loading' | translate }}</div>
    <div *ngIf="!loading && loadError" class="q-center q-error">
      {{ 'questionnaire.Link invalid or expired' | translate }}
    </div>

    <ng-container *ngIf="!loading && !loadError">

      <!-- header -->
      <div class="q-header">
        <div class="q-clinic" *ngIf="clinicName">{{ clinicName }}</div>
        <h1 class="q-title" *ngIf="questionnaire">{{ questionnaire.name }}</h1>
      </div>

      <!-- language toggle for 'both' questionnaires -->
      <div class="q-lang" *ngIf="bothLanguages() && screen !== 'done' && screen !== 'locked'">
        <button type="button" [class.active]="lang==='he'" (click)="lang='he'">עברית</button>
        <button type="button" [class.active]="lang==='en'" (click)="lang='en'">English</button>
      </div>

      <!-- ============ SCREEN: locked (already answered) ============ -->
      <div *ngIf="screen === 'locked'" class="q-screen q-center">
        <p class="q-lead">{{ 'questionnaire.This questionnaire was already answered' | translate }}</p>
        <p class="q-lead" *ngIf="answeredDate">
          {{ 'questionnaire.Submitted on' | translate }} {{ answeredDate | date: 'dd/MM/yyyy' }}
        </p>
        <p class="q-lead">{{ 'questionnaire.Contact the clinic to update your answers' | translate }}</p>
      </div>

      <!-- ============ SCREEN: identity (תז) ============ -->
      <div *ngIf="screen === 'id'" class="q-screen">
        <p class="q-lead">{{ 'questionnaire.Please identify with your ID number' | translate }}</p>
        <label class="q-field">
          <span class="q-label">{{ 'questionnaire.ID number' | translate }}</span>
          <input class="q-input" type="text" inputmode="numeric" autocomplete="off"
                 [(ngModel)]="ID" (ngModelChange)="idError=false; verifyError=false" dir="ltr" />
        </label>
        <div class="q-error" *ngIf="idError">{{ 'questionnaire.Invalid ID number' | translate }}</div>
        <div class="q-error" *ngIf="verifyError">{{ 'questionnaire.ID does not match' | translate }}</div>
        <button class="q-btn primary" (click)="verify()" [disabled]="verifying || !ID">
          {{ (verifying ? 'questionnaire.Checking' : 'questionnaire.Continue') | translate }}
        </button>
      </div>

      <!-- ============ SCREEN: answer form ============ -->
      <div *ngIf="screen === 'form'" class="q-screen">
        <ng-container *ngFor="let q of questions()">

          <!-- content blocks (opening / closing) -->
          <div *ngIf="isContentBlock(q.questionType)" class="q-question" [class.q-question--first]="isFirst(q)">
            <div class="q-block">{{ renderBlock(q) }}</div>
          </div>

          <!-- ordinary question -->
          <app-question-field
            *ngIf="!isContentBlock(q.questionType) && q.questionType !== 'repeatableGroup'"
            [q]="q" [key]="qKey(q)" [answers]="answers" [otherText]="otherText"
            [lang]="lang" [dirValue]="dir()" [invalid]="isInvalid(q, qKey(q))" [first]="isFirst(q)"
            (committed)="onFieldCommitted()">
          </app-question-field>

          <!-- AR-32: repeatable group -->
          <div *ngIf="q.questionType === 'repeatableGroup'" class="q-question q-group" [class.q-question--first]="isFirst(q)">
            <div class="q-qtext">{{ qText(q) }}<span class="q-req" *ngIf="q.required"> *</span></div>

            <div class="q-group-row" *ngFor="let row of groupRowIndexes(q)">
              <div class="q-group-row-head">
                <span class="q-group-row-title">{{ 'questionnaire.Record' | translate }} {{ row + 1 }}</span>
                <button type="button" class="q-group-remove" *ngIf="!q.repeatCountFromQuestionId"
                        (click)="removeRow(q, row)">
                  {{ 'questionnaire.Remove' | translate }}
                </button>
              </div>
              <app-question-field *ngFor="let sq of q.subQuestions; let sqi = index"
                [q]="sq" [key]="groupKey(q, row, sq)" [answers]="answers" [otherText]="otherText"
                [lang]="lang" [dirValue]="dir()" [invalid]="isInvalid(sq, groupKey(q, row, sq))" [first]="sqi === 0"
                (committed)="onFieldCommitted()">
              </app-question-field>
            </div>

            <button type="button" class="q-btn secondary q-group-add" *ngIf="!q.repeatCountFromQuestionId"
                    (click)="addRow(q)">
              {{ 'questionnaire.Add record' | translate }}
            </button>
          </div>

        </ng-container>

        <div class="q-error" *ngIf="submitError">{{ 'questionnaire.Please answer all required questions' | translate }}</div>
        <div class="q-error" *ngIf="dateRangeError">{{ 'questionnaire.One of your dates is out of the allowed range' | translate }}</div>
        <button class="q-btn primary" (click)="submit()" [disabled]="submitting">
          {{ (submitting ? 'questionnaire.Sending' : 'questionnaire.Submit') | translate }}
        </button>
      </div>

      <!-- ============ SCREEN: done ============ -->
      <div *ngIf="screen === 'done'" class="q-screen q-center">
        <div class="q-done-icon">✓</div>
        <p class="q-lead">{{ 'questionnaire.Thank you, your answers were saved' | translate }}</p>
      </div>

    </ng-container>
  </div>
</div>
